var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-placeholder"},[_c('p',[_vm._v("暂时还没有这样的纪录片哦～")]),_c('p',[_vm._v("看看其他3442部吧！")])])}]

export { render, staticRenderFns }